<main>
  <div class="content-container">
    @if (this.loaderService.loader$ | async) {
      <div class="loader">
        <div class="spinner-container">
          <embed src="assets/images/knab-loader.svg" type="image/svg+xml" width="200px" height="200px" />
        </div>
      </div>
    }
    <router-outlet />
  </div>
</main>
